import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { Colors } from "../theme";

export const LoginContain = styled(Box)(() => ({
  backgroundColor: Colors.color,
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  overflow: "hidden",
  "&::before, &::after": {
    content: '""',
    position: "fixed",
    width: "135px",
    height: "135px",
    borderRadius: "50%",
    backgroundColor: Colors.primary,
    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
    zIndex: 1,
  },
  "&::before": {
    bottom: "-70px",
    left: "-70px",
  },
  "&::after": {
    top: "-70px",
    right: "-70px",
  },
  "& .LoginLogo": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    maxWidth: "500px",
    width: "100%",
    margin: "auto",
    "& img": {
      width: "60px",
    },
  },
  "& .LoginCard": {
    maxWidth: "500px",
    width: "100%",
    padding: "40px",
    backgroundcolor: Colors.text,
    borderRadius: "15px",
    border: "1px solid " + Colors.border,
    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
    "& .LoginTitle": {
      marginBottom: "30px",
      "& h4": {
        fontSize: "28px",
        color: Colors.primary,
        textAlign: "center",
      },
      "& p": {
        textAlign: "center",
        fontSize: "14px",
        color: "gray",
      },
    },
    "& .LoginGroup": {
      marginBottom: "20px",
      "& label": {
        display: "block",
        fontSize: "14px",
        color: Colors.primary,
        marginBottom: "5px",
      },
      "& input": {
        width: "100%",
        padding: "10px",
        borderRadius: "8px",
        border: "1px solid #ccc",
        outline: "none",
        fontSize: "14px",
        backgroundColor: "#f9f9f9",
      },
      "& .password-container": {
        position: "relative",
        display: "flex",
        alignItems: "center",
        "& input": {
          flex: 1,
          paddingRight: "40px",
          borderRadius: "8px",
          border: "1px solid #ccc",
          padding: "10px",
          fontSize: "14px",
          backgroundColor: "#f9f9f9",
        },
        "& .password-toggle-icon": {
          position: "absolute",
          right: "10px",
          cursor: "pointer",
          width: "20px",
          height: "20px",
        },
        "& .password-tooltip": {
          position: "absolute",
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderRadius: "8px",
          padding: "10px 15px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
          zIndex: "1000",
          width: "250px",
          
          /* Default styles for larger screens (right side positioning) */
          top: "50%",
          left: "calc(100% + 10px)",
          transform: "translateY(-50%)",

          "& h5": {
            margin: "0 0 8px 0",
            fontSize: "14px",
            color: "#333",
          },
          "& ul": {
            margin: 0,
            paddingLeft: "20px",
            listStyle: "none",
          },
          "& li": {
            margin: "4px 0",
            color: "#777",
            fontSize: "12px",
            "&::before": {
              content: "'•'",
              marginRight: "8px",
              color: "#ccc",
            },
          },
          "& .requirement-met": {
            color: "#28a745",
            "&::before": {
              content: "'✓'",
              color: "#28a745",
            },
          },

          /* Arrow for larger screens (pointing left) */
          "&::before": {
            content: "''",
            position: "absolute",
            left: "-6px",
            top: "50%",
            transform: "translateY(-50%)",
            width: "0",
            height: "0",
            borderTop: "6px solid transparent",
            borderBottom: "6px solid transparent",
            borderRight: "6px solid #ddd",
          },
          "&::after": {
            content: "''",
            position: "absolute",
            left: "-5px",
            top: "50%",
            transform: "translateY(-50%)",
            width: "0",
            height: "0",
            borderTop: "5px solid transparent",
            borderBottom: "5px solid transparent",
            borderRight: "5px solid #fff",
          },

          /* Media query for screens <= 1024px */
          "@media (max-width: 1024px)": {
            /* Position below input instead of right side */
            top: "calc(100% + 10px)",
            left: "0",
            transform: "none",
            width: "100%",

            /* Change arrow to point upward */
            "&::before": {
              left: "20px",
              top: "-6px",
              transform: "none",
              borderLeft: "6px solid transparent",
              borderRight: "6px solid transparent",
              borderBottom: "6px solid #ddd",
              borderTop: "none",
            },
            "&::after": {
              left: "21px",
              top: "-5px",
              transform: "none",
              borderLeft: "5px solid transparent",
              borderRight: "5px solid transparent",
              borderBottom: "5px solid #fff",
              borderTop: "none",
            },
          },

          /* Media query for very small screens */
          "@media (max-width: 480px)": {
            width: "calc(100vw - 40px)", // Adjust width for very small screens
            maxWidth: "100%",
            left: "50%",
            transform: "translateX(-50%)",
            
            /* Center the arrow */
            "&::before": {
              left: "50%",
              marginLeft: "-6px",
            },
            "&::after": {
              left: "50%",
              marginLeft: "-5px",
            },
          },
        },
      },
      "& .error": {
        color: "red",
        fontSize: "14px",
        marginTop: "5px",
      },
    },
    "& .LoginBtn": {
      textAlign: "center",
      "& button": {
        padding: "10px 20px",
        fontSize: "16px",
        backgroundColor: Colors.primary,
        color: Colors.text,
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        transition: "background-color 0.3s ease",
        "&:hover": {
          backgroundColor: Colors.hover,
        },
      },
      "& button:disabled": {
        backgroundColor: "#ccc",
        cursor: "not-allowed",
      },
    },
    "& .CheckBox": {
      textAlign: "right",
      "& a": {
        fontSize: "12px",
        color: Colors.primary,
        textDecoration: "none",
        "&:hover": {
          textDecoration: "underline",
        },
      },
    },
  },
   /* Integrated password requirements popup styles */
   "& .password-requirements-popup": {
    backgroundColor: "#f9f9f9",
    border: "1px solid #ddd",
    borderRadius: "8px",
    padding: "10px 15px",
    marginTop: "8px",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    fontSize: "12px",
    "& h5": {
      margin: "0 0 8px 0",
      fontSize: "14px",
      color: "#333",
    },
    "& ul": {
      margin: 0,
      paddingLeft: "20px",
    },
    "& li": {
      margin: "4px 0",
      color: "#777",
    },
  },
  "& .requirement-met": {
    color: "#28a745 !important",
    fontWeight: 500,
  },

}));

export const LoginFooter = styled(Box)(() => ({
  backgroundColor: "#f5f5f5",
  color: Colors.grayText,
  padding: "10px",
  position: "fixed",
  bottom: "0",
  left: "0",
  width: "100%",
  "& p": {
    margin: "0",
    fontSize: "10px",
    textAlign: "center",
    "& span": {
      color: Colors.primary,
    },
  },
}));